import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

export default function AdminRoute({ children }) {
  const { isAuthenticated, user, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    // Attendre que l'authentification soit vérifiée
    if (!loading) {
      // Si l'utilisateur n'est pas authentifié ou n'est pas admin
      if (!isAuthenticated || (user?.role?.toLowerCase() !== 'admin' && !user?.isAdmin)) {
        console.log('Accès refusé - Redirection vers la page d\'accueil')
        navigate('/', { replace: true })
      }
    }
  }, [isAuthenticated, user, loading, navigate])

  // Afficher un loader pendant la vérification
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#141835] mx-auto mb-4"></div>
          <p className="text-gray-600">Vérification des permissions...</p>
        </div>
      </div>
    )
  }

  // Si l'utilisateur n'est pas admin, ne rien afficher (redirection en cours)
  if (!isAuthenticated || (user?.role?.toLowerCase() !== 'admin' && !user?.isAdmin)) {
    return null
  }

  // Si l'utilisateur est admin, afficher le contenu
  return children
}

